import emails from './emails';

export default emails;
